const doc = [({"en":({"js":({"admin":({"photo_products":({"resource_select":({"select_resource_type":"Select resource type"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;